import * as actionTypes from './actionTypes';
import { resetState } from '@app/src/commons/sidebar/state/sidebar/actions';
import { serviceUser } from './services';
import { getHttpReponseCodeMessage } from '@app/src/utils/validations';
import { HttpStatus } from '@app/src/utils/validations/constants';

const fetchLoginRequest = () => ({
  type: actionTypes.FETCH_LOGIN_REQUEST
});

const fetchLoginFailure = (errorMessage: string) => ({
  type: actionTypes.FETCH_LOGIN_FAILURE,
  errorMessage
});

const fetchLoginSuccess = (data) => ({
  type: actionTypes.FETCH_LOGIN_SUCCESS,
  data
});

export const fetchLogin = (values, history, url): Function => {
  return async dispatch => {
    dispatch(fetchLoginRequest());
    try {
      const data = await serviceUser.login(values, url);
      if (data.code === HttpStatus.LOGIN_ERROR) {
        dispatch(fetchLoginFailure(data.message));
        return;
      }
      dispatch(fetchLoginSuccess(data));
      sessionStorage.setItem('mfaAccessToken', data.user.accessToken);
      history.push('/mfa');
    } catch(e) {
      const response = e.response;
      let message = getHttpReponseCodeMessage(e.status, response);
      dispatch(fetchLoginFailure(message));
    }
  }
}

export const userLogout = (history: any = null): Function => {
  return dispatch => {
    sessionStorage.clear();
    localStorage.clear();
    if(history){
      history.push('/');
    }else{
      window.location.href = '/';
    }
    dispatch(resetState());
  }
}
